export interface ErrorResponse {
  error: {
    code: string;
    message: string;
  };
}

export class AppError extends Error {
  public readonly code: string;

  constructor(message: string, code: string = 'UNKNOWN_ERROR') {
    super(message);
    this.name = 'AppError';
    this.code = code;
  }

  toJSON(): ErrorResponse {
    return {
      error: {
        code: this.code,
        message: this.message,
      },
    };
  }
}